export default __webpack_public_path__ + "static/media/Background_00252.e01bd388.png";